import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./App.css";
import logo from "./assets/avaamo.svg";

class Header extends Component {
  render() {
    return (
      <div className="topnav">
        <Link to="/">
          <img className="logo" src={logo} height="48px" alt="" />
        </Link>

        <Link to="/">
          <span id="toolTitleText">Custom Voice Trainer</span>
        </Link>

        <Link to="/tutorial" data-title="Need Help?" data-tooltip="bottom" className={`get-help ${window.location.pathname !== '/record' ? 'sr-only' : ''}`}>
          Help
        </Link>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/App/Header.js